export default "/assets/images/app-update-img-03.png?a97cbe3e1dba0ebc1523e83089aacef5";